/* @ngInject */
function RequestCardController ($rootScope, $scope, $translate, Utils) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.getRequestId = (request) => {
    return `#${request.name}`
  }

  $scope.getRequestedBy = (request) => {
    const requestedByText = $translate.instant('requestedBy')

    return `${requestedByText}: ${request.author.name}`
  }

  $scope.getCreatedAtTooltip = (request) => {
    const requestDate = request.createdAt
    const locale = $rootScope.oUser.locale

    const createdAt = $translate.instant('createdIn')
    const date = Utils.formatDate(requestDate, locale)
    const time = Utils.formatDate(requestDate, locale, {
      hour: 'numeric',
      minute: 'numeric'
    })

    return `${createdAt}: ${date} - ${time}`
  }
}

export { RequestCardController }
